// components/Badges.jsx

// ✅ Short display names for long statuses
const displayNames = {
  verification_in_progress: "Verifying",
  driver_on_the_way: "On the way",
  trip_started: "In Trip",
  trip_completed: "Completed",
};

export default function Badges({ status }) {
  const styles = {
    // Driver statuses
    applied: {
      color: "#0055B3",
      background: "#E0F0FF",
      icon: "📝",
    },
    verification_in_progress: {
      color: "#7C3AED",
      background: "#EDE9FE",
      icon: "🔍",
    },
    waiting: {
      color: "#A37B00",
      background: "#FFF8E1",
      icon: "🕒",
    },
    approved: {
      color: "#0F6E56",
      background: "#E1F5EE",
      icon: "✅",
    },
    rejected: {
      color: "#A32D2D",
      background: "#FCEBEB",
      icon: "🚫",
    },
    online: {
      color: "#117A3E",
      background: "#E4F9ED",
      icon: "🟢",
    },
    offline: {
      color: "#854F0B",
      background: "#FEF3E2",
      icon: "🔴",
    },
    confirmed: {
      color: "#7C3AED",
      background: "#EDE9FE",
      icon: "🤝",
    },

    // Ride statuses
    requested: {
      color: "#0055B3",
      background: "#E0F0FF",
      icon: "🔔",
    },
    accepted: {
      color: "#B45309",
      background: "#FEF3C7",
      icon: "🛺",
    },
    driver_on_the_way: {
      color: "#1D4ED8",
      background: "#DBEAFE",
      icon: "🛣️",
    },
    trip_started: {
      color: "#7C3AED",
      background: "#EDE9FE",
      icon: "🛺",
    },
    trip_completed: {
      color: "#0F6E56",
      background: "#E1F5EE",
      icon: "✔️",
    },
    canceled: {
      color: "#A32D2D",
      background: "#FCEBEB",
      icon: "❌",
    },
    declined: {
      color: "#6B7280",
      background: "#F3F4F6",
      icon: "👎",
    },
  };

  const style = styles[status] || {
    color: "#555",
    background: "#EEE",
    icon: "•",
  };

  // ✅ Use short display name if available, otherwise use status as-is
  const label = displayNames[status] || status;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "4px 10px",
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        color: style.color,
        backgroundColor: style.background,
        whiteSpace: "nowrap",
      }}
    >
      <span>{style.icon}</span>
      {label}
    </span>
  );
}
